'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndNote } from '../../Entities/Ind/IndNote';
import { IndNoteCollection } from '@api/Collections/Ind/IndNoteCollection';

export class IndNoteRepository extends CoreRepository {
  public getIndNotes(indId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getIndNotes(indId, options).then((response) => {
      const collection = new IndNoteCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new IndNote();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public createIndsNotes(payload: object = {}) {
    return this.webAPI.createIndsNotes(payload).then((response) => {
      return response;
    });
  }

  public createIndNote(individualId: number, payload: object = {}) {
    return this.webAPI.createIndNote(individualId, payload).then((response) => {
      const indNote = new IndNote();
      indNote.hydrate(response);

      return indNote;
    });
  }

  public updateIndNote(indId: number, indNoteId: number, payload: any[]) {
    return this.webAPI.updateIndNote(indId, indNoteId, payload).then((response) => {
      return response;
    });
  }

  public moveIndNotes(userId: number, individualId: number, payload: any[]) {
    return this.webAPI.moveIndNotes(userId, individualId, payload).then((response) => {
      return response;
    });
  }
}
